// TGF. lightweight storefront enhancements.
document.addEventListener('DOMContentLoaded', () => {
  let qaEnabled = new URLSearchParams(window.location.search).has('tgf_qa');
  try {
    qaEnabled = qaEnabled || localStorage.getItem('tgf_qa') === '1';
  } catch (_) {
    // Keep the URL flag working even if storage is unavailable.
  }

  if (qaEnabled) {
    try {
      localStorage.setItem('tgf_qa', '1');
    } catch (_) {
      // Keep QA logging available for the current page even if storage is unavailable.
    }

    window.addEventListener('error', (event) => {
      console.info('[TGF QA] error', event.message, event.filename, event.lineno, event.colno);
    });

    window.addEventListener('unhandledrejection', (event) => {
      console.info('[TGF QA] unhandledrejection', event.reason);
    });

    document.addEventListener('cart:error', (event) => {
      console.info('[TGF QA] cart:error', event.detail);
    });

    document.addEventListener('cart:update', (event) => {
      console.info('[TGF QA] cart:update', event.detail);
    });
  }

});
